import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialsModule } from '@library/common/materials';

import { SaveChangesGuard, SaveChangesDialogComponent } from './save-changes.guard';

@NgModule({
   imports: [ CommonModule, MaterialsModule ],
   declarations: [ SaveChangesDialogComponent ],
   providers: [
      SaveChangesGuard,
   ]
})
export class GuardsModule { }
